module.exports = __webpack_public_path__ + "img/gjdw.104f2d6b.jpg";